import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom"; // 1. Import hooks
import "./Common_Send_Button.css";

import Send_Button_Modal from "../common-modals/send-btn-modal/Send_Button_Modal";
import Call_Now_Modal from "../common-modals/call-now-modal/Call_Now_Modal";
import { Context } from "../../../utils/context";

function Common_Send_Button({ vendor, onClick, onClick2, onClick3 }) {
  const { signin, userdata } = useContext(Context);

  const [showInquiry, setShowInquiry] = useState(false);
  const [showCall, setShowCall] = useState(false);

  const hasSubscription =
    userdata?.subscription_status === true &&
    Array.isArray(userdata?.user_subscription) &&
    userdata.user_subscription.length > 0;

  const navigate = useNavigate();
  const location = useLocation();

  // const handleInquiryClick = () => {
  //   if (!signin) {
  //     navigate("/login");
  //   } else {
  //     onClick?.();
  //   }
  // };

  const handleInquiryClick = () => {
    if (!signin) {
      navigate("/login");
      return;
    }

    // ❌ Block if no subscription
    if (!hasSubscription) {
      onClick?.("NO_SUBSCRIPTION"); // pass flag
      return;
    }

    onClick?.(); // normal flow
  };
  return (
    <div className="button-section">
      <Button className="inquiry-btn" onClick={handleInquiryClick}>
        Send Inquiry
      </Button>
    </div>
  );
}

export default Common_Send_Button;
